// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3662 ? "29107295" : chunkId) + "." + {"1567":"4efede39d31ea62d","2741":"653c787f2490dc24","3662":"89bb7fca8641b58a","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};